import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

import { CheckOutReviewInfoDto, UserOrderStatusDto, ResultWrapper, UserCheckOutAddressDto, UserCheckOutShippingDto, UserOrderAddressDto, PaymentProcessingRequest, UserAccountRegDto, TestSessionForRegistrationDto, TestPurposeDto } from '../dtos/dto';
import { ConfigHelper } from './helpers/config.helper';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  constructor(
    private http: HttpClient,
    private configHelper: ConfigHelper,
    private router: Router
  ) {
    if (!sessionStorage.getItem('affiliateCheckoutAvailable')) {
      this.resetAffiliateTracking();
    }
  }

  setLastCheckoutOrderNumber(lastOrderNumber: string, checkoutFlow: CheckoutWorkflowEnum) {
    sessionStorage.setItem('lastOrderNumber', lastOrderNumber);
    sessionStorage.setItem('checkoutFlow', checkoutFlow);
    sessionStorage.setItem('affiliateCheckoutAvailable', 'true');
  }

  setLastCheckoutFlow(checkoutFlow: CheckoutWorkflowEnum) {
    sessionStorage.setItem('checkoutFlow', checkoutFlow);
  }

  getLastCheckoutOrderNumber(): string {
    return sessionStorage.getItem('lastOrderNumber');
  }

  resetAffiliateTracking() {
    sessionStorage.setItem('affiliateCheckoutAvailable', 'false');
  }

  getAffiliateCheckoutAvailableStatus(): string {
    return sessionStorage.getItem('affiliateCheckoutAvailable');
  }

  getLastCheckoutFlow(): string {
    return sessionStorage.getItem('checkoutFlow');
  }

  redirectCheckoutCompleteBasedOnFlow(currentWorkFlow: CheckoutWorkflowEnum) {
    const workflow = this.getLastCheckoutFlow();
    if (workflow && workflow === CheckoutWorkflowEnum.NoRegCheckout && currentWorkFlow !== CheckoutWorkflowEnum.NoRegCheckout) {
      this.router.navigate(['checkout/done']);
    } else if (workflow && workflow === CheckoutWorkflowEnum.RegCheckOut && currentWorkFlow !== CheckoutWorkflowEnum.RegCheckOut) {
      this.router.navigate(['registration/order-complete']);
    }
    else {
      return;
    }
  }

  redirectCheckoutBasedOnFlow(currentWorkFlow: CheckoutWorkflowEnum) {
    const workflow = this.getLastCheckoutFlow();
    if (workflow && workflow === CheckoutWorkflowEnum.NoRegCheckout && currentWorkFlow !== CheckoutWorkflowEnum.NoRegCheckout) {
      this.router.navigate(['checkout/review']);
    } else if (workflow && workflow === CheckoutWorkflowEnum.RegCheckOut && currentWorkFlow !== CheckoutWorkflowEnum.RegCheckOut) {
      this.router.navigate(['registration/order-summary']);
    }
    else {
      return;
    }
  }

  getCheckoutAddressInformation(): Observable<ResultWrapper<UserCheckOutAddressDto>> {
    return this.http.get<ResultWrapper<UserCheckOutAddressDto>>(this.configHelper.getApiUrl("User/CheckOutInfo/OrderAddress"));
  }

  setCheckoutAddressInformation(addressInfo: UserOrderAddressDto) {
    return this.http.put(this.configHelper.getApiUrl("User/CheckOutInfo/OrderAddress"), addressInfo);
  }

  getShippingInfo(): Observable<ResultWrapper<UserCheckOutShippingDto>> {
    return this.http.get<ResultWrapper<UserCheckOutShippingDto>>(this.configHelper.getApiUrl("User/CheckOutInfo/Shipping"));
  }

  setShippingInfo(shippingMethodId: number) {
    return this.http.put(this.configHelper.getApiUrl("User/CheckOutInfo/Shipping"), { ShippingMethodId: shippingMethodId });
  }

  prepareCartForShipping() {
    return this.http.post(this.configHelper.getApiUrl("User/CheckOut/PrepareForShipping"), {});
  }

  updateFinalInfo(): Observable<ResultWrapper<CheckOutReviewInfoDto>> {
    return this.http.post<ResultWrapper<CheckOutReviewInfoDto>>(this.configHelper.getApiUrl("User/CheckOutInfo/Final"), {});
  }

  placeOrder(paymentMethodId: number): Observable<ResultWrapper<PaymentProcessingRequest>> {
    return this.http.post<ResultWrapper<PaymentProcessingRequest>>(this.configHelper.getApiUrl("User/CheckOut/Order"), { PaymentMethodId: paymentMethodId });
  }

  applyDiscountCode(code: string) {
    return this.http.post(this.configHelper.getApiUrl("User/CheckOut/ApplyDiscountCode"), { Code: code });
  }

  getLastOrderStatus(orderNumber: string): Observable<ResultWrapper<UserOrderStatusDto>> {
    const params = new HttpParams().set('orderNumber', orderNumber);
    return this.http.get<ResultWrapper<UserOrderStatusDto>>(this.configHelper.getApiUrl("UserOrder/Status"), { params });
  }

  getShoppingCartReg(userAccountId: number): Observable<ResultWrapper<UserAccountRegDto>> {
    const params = new HttpParams().set('userAccountId', userAccountId.toString());
    return this.http.get<ResultWrapper<UserAccountRegDto>>(this.configHelper.getApiUrl("UserOrder/getShoppingCartReg"), { params });
  }

  getShoppingCartRegTestPurpose(userAccountId: number): Observable<ResultWrapper<TestPurposeDto>> {
    const params = new HttpParams().set('userAccountId', userAccountId.toString());
    return this.http.get<ResultWrapper<TestPurposeDto>>(this.configHelper.getApiUrl("UserOrder/getShoppingCartRegTestPurpose"), { params });
  }

}

export enum CheckoutWorkflowEnum {
  RegCheckOut = "RegCheckOut",
  NoRegCheckout = "NoRegCheckout"
}

